

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from 'firebase/firestore'; 
import { DataSopralluogoFase1DTO } from "src/app/models/dto/dataSopralluogoFase1.model";
  

@Component({
    selector: "component-data-sopralluogo-fase1",
    templateUrl: "./dialog-data_sopralluogo_fase1.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogComunicaDataSopralluogoFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected comunicaDataSopralluogoFase1Form: FormGroup;
    protected isComunicandoDataSopralluogoFase1:boolean = false;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private messageService: MessageService,
    ) {
      this.pratica          = this.config.data.pratica;
      const dataSopralluogo = this.pratica.dataSopralluogo 
          ? this.convertFirestoreTimestampToDate(this.pratica.dataSopralluogo) 
          : null;
      this.comunicaDataSopralluogoFase1Form = this.formBuilder.group({
        dataSopralluogo:        [ dataSopralluogo, [Validators.required]]
      });
      
    }
    ngOnInit() {
    }

    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isComunicandoDataSopralluogoFase1 = true;
        let sopralluogo:DataSopralluogoFase1DTO = new DataSopralluogoFase1DTO();
        sopralluogo.dataPianificata = this.comunicaDataSopralluogoFase1Form.get('dataSopralluogo').value;
        this.praticheService.comunicaDataSopralluogo(this.pratica.id, sopralluogo).subscribe( {
          next: (res) => {
            this.isComunicandoDataSopralluogoFase1 = false;
            this.dialogRef.close({ success: true});
          },  error: (e) => {
            this.isComunicandoDataSopralluogoFase1 = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di comunicazione della data del sopralluogo di fase 1!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {

          }
        }
      );
       }
    }
  
  }